import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Modal } from 'react-bootstrap'
import UserService from "../../controllers/UserService";
import AuthService from "../../controllers/AuthService";
import $ from 'jquery'


const RFStudentEvaluate = props => {
    
    const { studentId , assessorParam} = useParams();
    const currentUser = AuthService.getCurrentUser();
    let [question, setQuestion] = useState([]);
    let [roomId, setRoomId] = useState('');
    // let currentDiv = 0;
    let [currentDiv, setCurrentDiv] = useState(0);
    let rawQuestion = [];
    let stdId = studentId;
    let userR = '';
    let [showAlert, setShowAlert] = useState(false);
    let [textAlert, setTextAlert] = useState('textAlert');
    let [awsContent, setAwsContent] = useState([]); 
    let [textAlertEnd, setTextAlertEnd] = useState('');
    let [showBtnEnd, setShowBtnEnd] = useState(true);
    let [showBtnGoHome, setShowBtnGoHome] = useState(false);
    let [stdNameForTeacher, setStdNameForTeacher] = useState('');
    let [stdInputName, setStdInputName] = useState('นักเรียน');
    const [modalShow, setModalShow] = useState(false);  
    const [hideTop1, setHideTop1] = useState(true);  
    const [hideTop2, setHideTop2] = useState(true);  
    const [selectFromTop1, setSelectFromTop1] = useState('');  
    const [top1Select,setTop1Select]= useState('');  
    let inputName = stdInputName;
    let top1SelectTemp = '';

    let cdiv = 0;
    let htmlTemp  = '';
    let getString = '';
    if(currentUser && assessorParam !== 'parent'){
        const userRole = AuthService.getUserRole();     
        userR = userRole;           
      
    } else {
        userR = 'parent';
    }

    
    useEffect(() => {
        $('.div-question').addClass('d-none');
        props.onChange({ 'backgroundColor': 'bg-lightness-blue' })
        try {
            // if parent evaluate
            if (userR !== 'headmaster') {
                UserService.getCognitorUserByUser(studentId)
                .then((response) => { 
                    if (response.data && response.data.data) {
                        const u = response.data.data
                        UserService.getRiasecResult(u.room.id, u.id, userR.toUpperCase())
                            .then((res) => { 
                            if (res.data && res.data.data && res.data.data[0]) {
                                if (userR === 'parent') {
                                     window.location.href =  `/report/riasec/${u.room.id}/${studentId}/parent`
                                } else {
                                    window.location.href =  `/report/riasec/${u.room.id}/${studentId}`
                                }
                            }
                        })
                    }
                })
               
            }

            let filter = {};

            UserService.getUserById(stdId).then((response) => {
                if (response.data && response.data.data ) {
                    console.log(response.data.data);
                    setRoomId(response.data.data.room.id);
                    if(userR === 'teacher'){
                        setStdNameForTeacher(response.data.data.fullName);
                    }
                  
                    roomId = response.data.data.room.id;                    
                    filter = {
                        'grade': response.data.data.room.grade,
                        'gradeYear': response.data.data.room.gradeYear,      
                        'targetAssessor' : userR   
                    }

                    // -----------------------------------------------------------------------------
                    UserService.getRiasecQuestion(filter).then((response) => {
                        let que= response.data.data[0].questions;
                        rawQuestion = [...que];
                        if(userR === 'student') {
                            setAwsContent([
                                "ตรงกับตัวนักเรียน",
                                "ค่อนข้างตรงกับตัวนักเรียน",
                                "ตรงและไม่ตรงกับตัวนักเรียนพอๆ กัน",
                                "ค่อนข้างไม่ตรงกับตัวนักเรียน",
                                "ไม่ตรงกับตัวนักเรียนเลย"
                            ]);
                            
                            htmlTemp  = `<p class="mt-3 pt-3"><span class="text-green t-30">“สวัสดีชื่ออะไรหรอ”</span>`;
                            htmlTemp = <div dangerouslySetInnerHTML={{ __html: htmlTemp }}/>
                            que.splice(0, 0, {'content' : true,'btnNextText':'นี่ชื่อเราเอง >','html' : htmlTemp, 'getStdName': true,}); 

                            htmlTemp  = `<p class="mt-lg-3"></p><img class="m-auto img-endpage" src='/images/riasec/story/ss1.png'} /> <p class="text-green t-30 has-name">สวัสดี “นักเรียน” ยินดีที่รู้จักนะ</p><p class="text--white t-20 font-sarabun-bold">ใช้ชีวิตวัยวุ่น เอ้ย วัยรุ่นเป็นยังไงบ้าง?</p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(1, 0, {'content' : true,'btnNextText':'การบ้านอย่างเยอะ >','html' : htmlTemp, 'countNext2': 2, 'btnNextText2': 'สนุกดีนะๆ >'}); 

                            htmlTemp  = `<p class="mt-3"></p><img class="m-auto img-endpage" src='/images/riasec/story/ss2.png'} /> <p class="text-green t-30">ฮ่าๆ ค่อยๆ ทำๆ นะ</p><p class="text--white t-20 font-sarabun-bold">แต่อย่ามัวแต่ทำการบ้านน๊าา อย่าลืมใช้ชีวิตวัยรุ่นด้วย เพราะรู้เปล่านี่เป็น ช่วงเวลาที่ดีที่สุด!! เลยนะ</p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(2, 0, {'content' : true,'btnNextText':'ยังไงๆ ใครๆ ก็บอกแบบนี้ >','html' : htmlTemp, 'countNext': 2}); 

                            htmlTemp  = `<img class="m-auto img-endpage" src='/images/riasec/story/ss3.png'} /> <p class="text-green t-30">ใช่ๆ ช่วงนี้แหละ <span class='doNotWrap'>ที่ชีวิตเราจะสนุกแบบสุดๆ</span></p><p class="text--white t-20 font-sarabun-bold">แต่รู้เปล่านี่เป็นช่วงเวลา<span class='doNotWrap'>ที่ดีที่สุด!! เลยนะ</span></p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(3, 0, {'content' : true,'btnNextText':'ยังไงๆ ใครๆ ก็บอกแบบนี้ >','html' : htmlTemp}); 

                            htmlTemp  = `<img class="m-auto img-endpage" src='/images/riasec/story/ss4.png'} /> <p class="text-green t-30">“เป็นช่วงเวลาที่สนุกมากกกแบบกอไก่ล้านตัว และเราจะเจอเพื่อนมากมายหลายแบบเลย”</p><p class="text--white t-20 font-sarabun-bold">มันจะมีทั้งเพื่อนที่เราชอบ และเราก็ไม่ชอบใช่มั้ยล่าา</p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(4, 0, {'content' : true,'btnNextText':'แน่นอน >','html' : htmlTemp}); 

                            htmlTemp  = `<p class="mt-3 pt-3"></p><p class="text-green t-30">“แต่สังเกตมั้ย? ว่าแต่ละคนไม่เหมือนกันเลยนะ”</p><img class="m-auto img-endpage" src='/images/riasec/story/ss5.png'} />`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(5, 0, {'content' : true,'btnNextText':'จริงด้วยนะ >','html' : htmlTemp}); 

                            htmlTemp  = `<p class="mt-lg-3"></p><img class="m-auto img-endpage" src='/images/riasec/story/ss6.png'} /> <p class="text-green t-30">“เราก็อาจจะชอบอุปนิสัยของเพื่อนบางคน หรือไม่ชอบบางอย่างในเพื่อนอีกคนเช่นกัน”</p><p class="text--white t-20 font-sarabun-bold">แต่เราไม่อยากให้แกตัดสินหรือวัดคุณค่าใครแบบนั้นนะ</p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(6, 0, {'content' : true,'btnNextText':'อ๋าาาา >','html' : htmlTemp}); 

                            htmlTemp  = `<p class="mt-lg-3"></p><img class="m-auto img-endpage" src='/images/riasec/story/ss7.png'} /> <p class="text-green t-30">เพราะแต่ละคนมีลักษณะเฉพาะตัวที่ไม่เหมือนกัน ทั้งบุคลิก ความชอบ ความถนัด อุปนิสัย</p><p class="text--white t-20 font-sarabun-bold">ว่าแต่เธอได้เรียนเรื่องระบบสุริยะมาใช่มั้ย</p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(7, 0, {'content' : true,'btnNextText':'เล่าต่อๆ >','html' : htmlTemp}); 
                            
                            htmlTemp  = `<p class="text-green t-30 pt-4 mt-4">เราว่าทุกคนก็เหมือนดาวฤกษ์ ที่มีเยอะแยะมากมายในจักรวาล </p><img class="m-auto img-endpage" src='/images/riasec/story/ss8.png'} />`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(8, 0, {'content' : true,'btnNextText':'เล่าต่อๆ >','html' : htmlTemp}); 

                            htmlTemp  = `<p class="mt-3"></p><img class="m-auto img-endpage" src='/images/riasec/story/ss9.png'} /><p class="text-green t-30">ทุกดวงอ่ะมีลักษณะเฉพาะตัวที่ไม่เหมือนกัน</p><p class="text--white t-20 font-sarabun-bold px-30">แสง รูปทรง วงโคจรก็ยังไม่เหมือนกันเลย</p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(9, 0, {'content' : true,'btnNextText':'เล่าต่อๆ >','html' : htmlTemp}); 

                            htmlTemp  = `<img class="m-auto img-endpage" src='/images/riasec/story/ss10.png'} /><p class="text-green t-30">เราก็ไม่สามารถตัดสินได้ใช่เปล่าว่าดวงไหนดีกว่าดวงไหนสวยกว่า</p><p class="text--white t-20 font-sarabun-bold">ซึ่งมันมีสวยงามในแบบของมัน เธอกับเพื่อนๆ เธอก็เหมือนกันนะ :) ล้ำลึกม่ะ </p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(10, 0, {'content' : true,'btnNextText':'แล้วเราเป็นแบบไหนอ่ะ >','html' : htmlTemp}); 

                            htmlTemp  = `<p class="mt-3"></p><p class="text-green t-20">งั้นเอางี้ๆ เราขอสัก 10 - 15 นาทีสิ!</p><p class="text--white t-20 font-sarabun-bold">เราอยากพาไปดูว่าเธอเป็นดาวฤกษ์แบบไหนแหละ</p><img class="m-auto img-endpage" src='/images/riasec/story/ss11.png'} />`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(11, 0, {'content' : true,'btnNextText':'Let’s Go >>','html' : htmlTemp,'btnPink': true, "btnPopup": true} ); 

                            que.splice(42, 0, {'content' : true,'endpage': true});  
                            setQuestion(que);                           
                            console.log(que);                  
                            
                        } else if(userR === 'teacher') {
                          
                            setAwsContent([
                                "เห็นด้วยอย่างยิ่ง",
                                "เห็นด้วย",
                                "เห็นด้วยและไม่เห็นด้วยพอ ๆ กัน",
                                "ไม่เห็นด้วย",
                                "ไม่เห็นด้วยอย่างยิ่ง"
                            ]);

                            // que.splice(2, 0, {'content' : true,'header':'ลองตอบดูนะ', 'sendData': 'd-none', 'btn' : ''}); 
                            // que.splice(0, 0, {'content' : true,'endpage': true});  
                            // que.splice(1, 0, {'content' : true,'header':'จบแล้ว', 'sendData': '', 'btn' : 'd-none'});  
                            // que.splice(31, 0, {'content' : true, 'header':'จบแล้ว', 'sendData': '', 'btn' : 'd-none'});    
                            
                            que.splice(31, 0, {'content' : true,'endpage': true}); 

                            setQuestion(que);    
                        } else if(userR === 'parent'){
                            setAwsContent([
                                "ตรงกับตัวนักเรียน",
                                "ค่อนข้างตรงกับตัวนักเรียน",
                                "ตรงและไม่ตรงกับตัวนักเรียนพอๆ กัน",
                                "ค่อนข้างไม่ตรงกับตัวนักเรียน",
                                "ไม่ตรงกับตัวนักเรียนเลย"
                            ]);
                             
                            htmlTemp  = `<img class="m-auto img-endpage" src='/images/riasec/story/ps-1.png'} /><p class=""><span class="text-green t-30">สวัสดีจ้าคุณเป็นผู้ปกครองของน้อง</span>`;
                            htmlTemp = <div dangerouslySetInnerHTML={{ __html: htmlTemp }}/>
                            que.splice(0, 0, {'content' : true,'btnNextText':'ใช่แล้ว >','html' : htmlTemp, 'getStdName': true,}); 

                            htmlTemp  = `<p class=""></p><img class="m-auto img-endpage" src='/images/riasec/story/ps-2.png'} /> <p class="text-green t-30 has-name">น้อง “นักเรียน” น่ารักกับเพื่อนและเป็นเด็กดีของคุณครู</p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(1, 0, {'content' : true,'btnNextText':'ใช่แล้ว >','html' : htmlTemp}); 

                            htmlTemp  = `<p class=""></p><img class="m-auto img-endpage" src='/images/riasec/story/ps-3.png'} /> <p class="text-green t-30 has-name">ช่วงนี้ผู้ปกครองคงกำลังกังวลกับอนาคตของน้อง “นักเรียน” อยู่หรือเปล่า?</p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(2, 0, {'content' : true,'btnNextText':'ค่อนข้างกังวล >','html' : htmlTemp, 'countNext2': 2, 'btnNextText2': 'ไม่กังวลนะ >'}); 

                            htmlTemp  = `<p class="text-green t-30 pt-0 pt-lg-5 px-0 px-lg-4">ผู้ปกครองหลายคนก็กังวลในอนาคตของตัวลูก</span></p><p class="text--white t-20 font-sarabun-bold px-0 px-lg-5"">เพราะเขาอยู่ในวัยที่ต้องพบเจอและเปลี่ยนแปลงในหลายอย่าง</p><img class="m-auto img-endpage" src='/images/riasec/story/ps-4.png'} />`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(3, 0, {'content' : true,'btnNextText':'ใช่แล้ว >','html' : htmlTemp, 'countNext': 2}); 

                            htmlTemp  = `<p class="text-green t-30 bt-3">เยี่ยมเลย!!</p><p class="text--white t-20 font-sarabun-bold px-4">น้องน่าจะเป็นเด็กดีจนไม่น่าจะต้องห่วงเท่าไหร่</p><img class="m-auto img-endpage" src='/images/riasec/story/ps-5.png'} /> `;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(4, 0, {'content' : true,'btnNextText':'ช่าย >','html' : htmlTemp}); 

                            htmlTemp  = `<p class="mt-3 pt-3"></p><p class="text-green t-30 has-name">“นักเรียน” เคยบอกมั้ยว่าในอนาคตน้องอยากเป็นอะไร</p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(5, 0, {'content' : true,'btnNextText':'เคยบอก >','html' : htmlTemp, 'countNext2': 2, 'btnNextText2': 'ไม่เคยบอก >'}); 

                            htmlTemp  = `<p class="mt-lg-3"></p><img class="m-auto img-endpage" src='/images/riasec/story/ps-7.png'} /> <p class="text-green t-30" px-0 px-lg-5>ดีเลยช่วงนี้น้องก็คงกำลังทำตามฝันของตัวเอง</p><p class="text--white t-20 font-sarabun-bold px-4">แต่เราสามารถช่วยน้องได้นะอยากจะลองมั้ย</p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>
                            que.splice(6, 0, {'content' : true,'btnNextText':' มาช่วยกัน >','html' : htmlTemp,'countNext': 2, }); 

                            htmlTemp  = `<p class="mt-lg-3"></p><img class="m-auto img-endpage" src='/images/riasec/story/ps-8.png'} /> <p class="text-green t-30">น้องอาจจะยังไม่รู้ตัวว่าตัวเองอยากเป็นอะไรหรือเหมาะกับอะไร</p><p class="text--white t-20 font-sarabun-bold">แต่คุณพ่อคุณแม่ไม่ต้องเป็นห่วงหรอกเพราะเราจะมาช่วยกัน! ผ่านเครื่องมือ RIASEC</p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(7, 0, {'content' : true,'btnNextText':'มาช่วยกัน >','html' : htmlTemp}); 
                            
                            htmlTemp  = `<img class="m-auto img-endpage" src='/images/riasec/story/ps-9.png'} /><p class="text-green t-30">แต่ก่อนทำอย่าลืมว่าไม่ว่ายังไงมันก็เป็นชีวิตของเขา</p><p class="text--white t-20 font-sarabun-bold px-0 px-lg-5">เขาจะต้องเป็นคนเลือก และตัดสินใจเอง ไม่อยากให้ไปกดดันน้อง</p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(8, 0, {'content' : true,'btnNextText':'ไปต่อ >','html' : htmlTemp}); 

                            htmlTemp  = `<p class=""></p><p class="text-green t-30">เปิดใจเคยเล่าให้เขาฟังว่าชีวิตคนเราเหมือนดาวฤกษ์ ที่มีเยอะแยะมากมายในจักรวาล</p><p class="text--white t-20 font-sarabun-bold px-30">แต่ทุกดวงมีความสวยงามในแบบของมัน</p><img class="m-auto img-endpage" src='/images/riasec/story/ps-10.png'} />`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(9, 0, {'content' : true,'btnNextText':'เล่าต่อ >','html' : htmlTemp}); 

                            htmlTemp  = `<img class="m-auto img-endpage" src='/images/riasec/story/ps-11.png'} /><p class="text-green t-30">เพราะแต่ละคนก็มีลักษณะเด่นทั้งบุคลิก ความชอบ ความถนัด อุปนิสัย ที่ไม่เหมือนกัน</p>`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(10, 0, {'content' : true,'btnNextText':'เล่าต่อ >','html' : htmlTemp}); 

                            htmlTemp  = `<p class="mt-3"></p><p class="text-green t-20 has-name">เราไปช่วยกัน ค้นหาให้ “นักเรียน” กันเถอะ</p><p class="text--white t-20 font-sarabun-bold">เราอยากพาไปดูว่าเธอเป็นดาวฤกษ์แบบไหนแหละ</p><img class="m-auto img-endpage" src='/images/riasec/story/ss11.png'} />`;
                            htmlTemp = <div className='d-grid' dangerouslySetInnerHTML={{ __html: htmlTemp }}/>                            
                            que.splice(11, 0, {'content' : true,'btnNextText':'Let’s Go >>','html' : htmlTemp,'btnPink': true, "btnPopup": true} ); 
                            que.splice(42, 0, {'content' : true,'endpage': true});               
                            setQuestion(que); 
                        }
        
                    }).then(() => { 
                        
                    })
                   // -----------------------------------------------------------------------------
                }
            });

           
        } catch (error) {

        }
        
    }, []);
    

    const handleClickM = () => {      
        setHideTop1(false);
        setHideTop2(false);
        if(selectFromTop1 != ''){
            $('.'+selectFromTop1+'-top2').removeClass('d-none');        
        }
    }

    const handleClickNextM = () => {   
        setHideTop1(true);
        setHideTop2(false);

        var radioButtons = document.querySelectorAll('input[type="radio"][name="mTop1"]');

        // Loop through the radio buttons to find the selected one
        var selectedValue;
        for (var i = 0; i < radioButtons.length; i++) {
            if (radioButtons[i].checked) {
                selectedValue = radioButtons[i].value;
                break;
            }
        }
        //hide radio if already select at top1
        setSelectFromTop1(selectedValue);
        setTop1Select(selectedValue);
        $('.'+selectedValue+'-top2').addClass('d-none');        
       
    }

    const handleClick = event => {     
           
        if(currentDiv != 0){           
            setCurrentDiv(currentDiv-1)
        }       
      
    }

    const handleClickNext = (getStdName,countNext) => {   
        // console.log(countNext);


        if(currentDiv < question.length ){       
            
            if(countNext && countNext > 1 ){
                cdiv = parseInt(currentDiv)+parseInt(countNext)
            } else {
                cdiv = parseInt(currentDiv)+1
            }           
            console.log(cdiv);

            setCurrentDiv(cdiv);   
      
        }    

        if(getStdName != null){
            
            setStdInputName($('#nameStd').val()) 
            inputName = $('#nameStd').val();

           
            $( ".has-name" ).each(function( index ) {
                console.log( index + ": " + $( this ).text() );
                getString = $( this ).text();
                getString = getString.replace('นักเรียน', inputName);
                $( this ).text(getString);
            });
        }       
    }

    const resendSendAnswer = () => {
        let answer = GetAllSelectRadioButtons();     
        console.log(answer);
        var radioButtons = document.querySelectorAll('input[type="radio"][name="mTop2"]');
        var selectedValue;
        for (var i = 0; i < radioButtons.length; i++) {
            if (radioButtons[i].checked) {
                selectedValue = radioButtons[i].value;
                break;
            }
        }

        let selectNew = top1Select + selectedValue;
        top1SelectTemp = selectNew;
        setTop1Select(selectNew);
        sendAnswer(); 

    }

    const sendAnswer = () => {

            let answer = GetAllSelectRadioButtons();            
            let dataAnswer = {
                "roomId": roomId,
                "studentId": stdId,
                "assessor": userR.toUpperCase(),
                "answers": answer
            };  

            if(top1SelectTemp != ''){

                dataAnswer = {
                    "roomId": roomId,
                    "studentId": stdId,
                    "assessor": userR.toUpperCase(),
                    "answers": answer,
                    "top1select": top1SelectTemp
                };  
            } 
                        
            
            


            if(answer.length < 30){
                // alert('answer.length');
                setTextAlert('กรุณาตอบคำถามให้ครบทุกข้อ');
                setShowAlert(true)
            } else {
                
            try {  
               
                    UserService.postRiasecAnswer(stdId, dataAnswer).then(
                        (res) => {
                          console.log('pass');
                            if(userR === 'teacher') {
                                window.location.href = `/report/riasec/${roomId}/${stdId}/evaluate`
                            } else if (userR === 'parent') {
                                window.location.href =  `/report/riasec/${roomId}/${stdId}/parent`
                           } else {
                                window.location.href = `/report/riasec/${roomId}/${stdId}`
                            }
                          

                           
                        },
                        (error) => {
                            console.log('fail');
                            console.log(error);
                            if (error.response.data.status.code === 'INVALID_RIASEC_RESULT') {        
                                           
                                $('.div-question').addClass('d-none');
                                
                                var top1Count = error.response.data.data.top1
                                var top2Count = error.response.data.data.top2
                                var allTarget = ['R','I','A','S','E','C']
                               
                                if(top1Count.length >= 3){
                                    //select top1 and top 2 from top1
                                    setHideTop1(false);

                                    //set top1
                                    //sett top2
                                    for(let i = 0; i < allTarget.length; i++) {
                                        let divTarget1 = $('.'+allTarget[i]+"-top1");
                                        let divTarget2 = $('.'+allTarget[i]+"-top2");
                                        if(top1Count.includes(allTarget[i]) ){
                                            divTarget1.removeClass('d-none');
                                            divTarget2.removeClass('d-none');
                                        } else {
                                            divTarget1.addClass('d-none');
                                            divTarget2.addClass('d-none');
                                        }

                                    }                             

                                } else if (top1Count.length == 1 && top2Count.length >= 3) {
                                    $('.m-back').addClass('d-none');
                                    setHideTop1(true);
                                    setHideTop2(false);
                                    setTop1Select(top1Count[0]);

                                    for(let i = 0; i < allTarget.length; i++) {
                                       
                                        let divTarget2 = $('.'+allTarget[i]+"-top2");
                                        if(top2Count.includes(allTarget[i]) ){                                            
                                            divTarget2.removeClass('d-none');
                                        } else {                                    
                                            divTarget2.addClass('d-none');
                                        }

                                    }  
                                    
                                } else {
                                    setTextAlert('มีบางอย่างผิดพลาด กรุณาติดต่อผุ้ดูแลระบบ');
                                    setShowAlert(true);  
                                }                                        
                                
                            }

                            if (error.response.data.status.code === 'RECORD_ALREADY_EXIST') {    
                                setTextAlert('คุณได้ทำการประเมินแล้ว ไม่สามารถประเมินซ้ำได้ค่ะ');
                                setShowAlert(true)         
                                setShowBtnEnd(false) 
                                setShowBtnGoHome(true)                                                                   
                            }
                        
                            // window.location.reload(false);
                        }
                    )
                } catch (error) {

                }                
             
            }                  
    }


    function GetAllSelectRadioButtons() {
        // let arrInput = document.getElementsByTagName("input"), arrRadio = [];
        let arrInput = document.getElementsByClassName("aws"), arrRadio = [], awsData = {};

        let j = 0;
        for (let i = 0; i < arrInput.length; i++) {
                if (arrInput[i].type == "radio" && arrInput[i].checked) {
                       
                        awsData = {
                            'question': arrInput[i].getAttribute('data-q'),
                            'code' : arrInput[i].getAttribute('data-c'),
                            'score' : arrInput[i].value
                          
                        };
                        arrRadio[j] = awsData;
                        j++;
                }
        }
        return arrRadio;
    }

    const handleOnClickRadio = (event,selectId) => {
        var selectRadio = $("#" + selectId);
        // อย่าพึ่งให้ browser ส่ง click จาก label ไปติ๊ก input เอง
        // ส่วนขยายแปลภาษา (Google Translate) แก้ DOM ระหว่างคลิก ทำให้ label activation หลุดเป็นบางครั้ง
        // ผลคือแถบขึ้นสีชมพูแต่ radio ไม่ถูกติ๊ก และคำตอบข้อนั้นหายไปจาก GetAllSelectRadioButtons()
        selectRadio.prop('checked', true);
        var parentsDiv = selectRadio.parents(".div-radio");
        parentsDiv.find('.radio-btn').removeClass('riasec-radio-active');

        var selectDiv = selectRadio.parents(".radio-btn");
        selectDiv.addClass('riasec-radio-active');
       
        var qDiv = selectRadio.parents(".q-div");
        qDiv.find('.btn-next').addClass('riasec-btn-active');
        qDiv.find('.btn-next').removeClass('riasec-btn-none');
          
    }
    let html = (
        <Row className='p-0' style={{"backgroundColor": "#F4F8FF"}}>            
                {
                
                ( typeof question !== 'undefined') ? (
                    
                    (question).map((item, index) => {
                        // console.log(item)
                        return (           
                            <Col xs={12} className={`div-${index} div-question main-riasec riasec-100 p-0 ${currentDiv!=index?'d-none':''}`}  key={index}>   
                                { item.content ? (
                                                
                                    <div className="content riasec-100">      
                                        { item.endpage ? (   
                                            <div className="riasec-100 end-page p-rl-15">
                                               <Row style={{"paddingLeft": "15px", "paddingRight": "15px"}} className="riasec-pt-end">
                                                <Col xs={12} className='d-flex mb-3 pt-5'>
                                                    <img className="m-auto img-endpage" src={`/images/riasec/img-endpage.png`} />                                                  
                                                </Col>                                                
                                                <Col className="second-div2 m-auto p-4">      
                                                    <div className="w3-riasec-bg w3-round w-100 ">
                                                        <div className={`w3-container w3-round ${((100/30)*30) > 0 ? 'w3-bluesky' : ''}`} style={{"width": ((100/30)*30) + "%", "height":"10px"}}></div>
                                                        <img className="w3-riasec-image" src={`/images/riasec/airplane.png`} style={{"left": ((100/30)*(30)-10) + "%"}}></img>
                                                    </div>
                                                    <p className='text--white t-20 m-0 text-center font-sarabun-bold'>ยอดเยี่ยมมาก!! <br></br>เรามาลุ้นไปพร้อมกันดีกว่า</p>    
                                                    <div className='text-center mt-3'>
                                                        <Button className={`riasec-btn-active btn font-sarabun-bold font-sarabun-bold mx-1 px-3 t-18 ${!showBtnEnd?'d-none':''}`} onClick={handleClick}  style={{"minWidth": "107px"}}> ย้อนกลับ </Button>
                                                        <Button className={`riasec-btn-active btn font-sarabun-bold font-sarabun-bold mx-1 px-3 t-18 btn-next ${!showBtnEnd?'d-none':''}`} onClick={() => sendAnswer()} style={{"minWidth": "107px"}}>ดูผลลัพธ์ </Button>
                                                        <a href="/" className={`${!showBtnGoHome?'d-none':''}`}><Button className="riasec-btn-active btn font-sarabun-bold t-12 font-sarabun-bold mx-3" >กลับหน้าหลัก</Button></a>
                                                    </div>   
                                                    <div><p className='text-danger text-center mt-3'>{textAlertEnd}</p></div>      
                                                </Col>
                                                </Row> 
                                            </div>
                                        ) : (
                                               
                                            <div className="riasec-100 story-page p-rl-15">
                                               <Row style={{"paddingLeft": "15px", "paddingRight": "15px"}} className="riasec-pt-end">
                                                <div style={{"minHeight": "80vh", "width": "100vw", "display":"flex"}}>
                                                    <div className="m-auto">
                                                    <Col xs={12} className='d-flex pt-1'>
                                                        <div className='text-center m-auto px-2'>  
                                                            {item.html}                                                                          
                                                        </div>               
                                                    </Col>      
                                                    <Col xs={12} className={`${item.getStdName? 'd-flex': 'd-none'} pt-2`}>
                                                        <div className='text-center m-auto'>  
                                                                <input id="nameStd" className="story-input mt-3 mb-5"></input>         
                                                        </div>               
                                                    </Col>     
                                                    <Col xs={12} className="m-auto pt-2"> 
                                                        <div className='text-center'>                   
                                                            <Button className={`${item.btnPink? 'b-pink t-20' : 'b-blue'} btn font-sarabun-bold btn font-sarabun-bold text-story`} onClick={(event) => handleClickNext(`${item.getStdName? item.getStdName: null}`, `${item.countNext? item.countNext: null}`)}  id="next">{item.btnNextText}</Button>                                                        
                                                        </div>   
                                                    </Col>
                                                    <Col xs={12} className={`m-auto pt-3 ${item.countNext2 && item.btnNextText2? '' : 'd-none'}`}> 
                                                        <div className='text-center'>                   
                                                            <Button className={`b-blue btn font-sarabun-bold btn font-sarabun-bold`} onClick={(event) => handleClickNext(`${item.getStdName? item.getStdName: null}`,`${item.countNext2? item.countNext2: null}`)}  id="next">{item.btnNextText2}</Button>                                                        
                                                        </div>  
                                                    </Col>
                                                    <Col xs={12} className={`m-auto pt-2 ${item.btnPopup? '' : 'd-none'}`}> 
                                                        <div className='text-center'>   
                                                            <Button className={`b-popup btn font-sarabun-bold btn font-sarabun-bold mt-3`} onClick={() => { setModalShow(true); }}>ก่อนไปอยากรู้ก่อนว่าเราจะทำ <span className="doNotWrap">แบบประเมินนี้(RIASEC)</span> คืออะไร? ></Button>
                                                        </div>                                                     
                                                    </Col>
                                                    </div>
                                                </div>
                                                </Row> 
                                            </div>                                           
                                        )}         
                                    </div>       
                                ) : (
                                    
                                    <div className="q-div riasec-100 p-rl-15">
                                        <Row className='question-div'>                                      
                                        <Col className="p-4 mx-4 mb-4 mt-4 second-div">     
                                        <p className="mb-1  t-20 text-green">{stdNameForTeacher}</p>                                  
                                        <p><img className="" src={`/images/riasec/guestion.png`} style={{"width": "25px", "paddingBottom": "10px"}}></img><span className='text-green t-20 m-0 pl-2 font-sarabun-bold'>ข้อที่ {`${("0" + item.order ).slice(-2)}`}</span> <span className="t-14 text-light-violet">/ 30</span></p>
                                        <div className="w3-riasec-bg w3-round w-100">
                                            <div className={`w3-container w3-round ${((100/30)*(item.order-1)) > 0 ? 'w3-bluesky' : ''}`} style={{"width": ((100/30)*(item.order-1)) + "%", "height":"10px"}}></div>
                                            <img className="w3-riasec-image" src={`/images/riasec/airplane.png`} style={{"left": ((100/30)*(item.order-1)-5) + "%"}}></img>
                                        </div>

                                        <p className='text--white t-20 m-0 font-sarabun-bold'>{item.question}</p>                                        
                                        </Col>
                                        </Row>
                                        <Row>
                                        <Col xs={12} className='div-radio'>
                                            <div >
                                            <label htmlFor={`a1${item.order}`} style={{"width": "100%"}} className="label-radio px-2" onClick={(event) => handleOnClickRadio(event,`a1${item.order}`)}><div className="radio-btn d-flex border-radius-250 border-green"><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="5" name={`q${item.order}`} data-c={item.code}  data-q={item.question} className="aws font-sarabun-bold" id={`a1${item.order}`} /><span className="font-sarabun-bold pl-2">{awsContent[0]}</span></div></div></label>  
                                            <label htmlFor={`a2${item.order}`} style={{"width": "100%"}} className="label-radio px-2" onClick={(event) => handleOnClickRadio(event,`a2${item.order}`)}><div className="radio-btn d-flex border-radius-250 border-green"><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="4" name={`q${item.order}`} data-c={item.code} data-q={item.question}  className="aws font-sarabun-bold" id={`a2${item.order}`}/><span className="font-sarabun-bold pl-2">{awsContent[1]}</span></div> </div></label>  
                                            <label htmlFor={`a3${item.order}`} style={{"width": "100%"}} className="label-radio px-2" onClick={(event) => handleOnClickRadio(event,`a3${item.order}`)}><div className="radio-btn d-flex border-radius-250 border-green"><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="3" name={`q${item.order}`} data-c={item.code} data-q={item.question} className="aws font-sarabun-bold" id={`a3${item.order}`}/><span className="font-sarabun-bold pl-2">{awsContent[2]}</span></div> </div></label>  
                                            <label htmlFor={`a4${item.order}`} style={{"width": "100%"}} className="label-radio px-2" onClick={(event) => handleOnClickRadio(event,`a4${item.order}`)}><div className="radio-btn d-flex border-radius-250 border-green"><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="2" name={`q${item.order}`} data-c={item.code} data-q={item.question} className="aws font-sarabun-bold" id={`a4${item.order}`}/><span className="font-sarabun-bold pl-2">{awsContent[3]}</span></div>  </div></label>  
                                            <label htmlFor={`a5${item.order}`} style={{"width": "100%"}} className="label-radio px-2" onClick={(event) => handleOnClickRadio(event,`a5${item.order}`)}><div className="radio-btn d-flex border-radius-250 border-green"><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="1" name={`q${item.order}`} data-c={item.code} data-q={item.question} className="aws font-sarabun-bold" id={`a5${item.order}`}/><span className="font-sarabun-bold pl-2">{awsContent[4]}</span></div> </div></label>  
                                        
                                            <Row>
                                            <Col className="main-riasec text-center pt-3 pb-3">                                            
                                                <Button className="riasec-btn btn font-sarabun-bold t-18 font-sarabun-bold mx-1 px-3" onClick={handleClick}  style={{"minWidth": "107px"}}>&lt; ย้อนกลับ</Button>
                                                <Button className="riasec-btn-none btn font-sarabun-bold t-18 font-sarabun-bold mx-1 btn-next px-3" style={{"minWidth": "107px"}} onClick={handleClickNext} >ตกลง &gt;</Button>
                                                <br></br>                                               
                                            </Col>                                          
                                            </Row>
                                            </div>
                                        </Col>
                                        </Row>                                       
                                    </div>
                                
                            )}
                            
                            </Col>

                        )
                    }
                )) : (
                    <div></div>
                )
                
                }
           
        </Row>
      );

    let manual1     = (
        <Row className={`p-0 div-top1 ${hideTop1?'d-none':''}`} style={{"backgroundColor": "#F4F8FF"}}>        
          <Col xs={12} className={`div-manual main-riasec riasec-100 p-0`}  key='top1'>    
             <div className="q-div riasec-100">                
                <div className="riasec-100 story-page p-rl-15">
                    <Row style={{"paddingLeft": "0px", "paddingRight": "0px"}} className="riasec-pt-end">
                        <div style={{"minHeight": "80vh", "width": "100vw", "display":"flex"}}>
                            <div className="m-auto radio-top1 col-12">               
                                <div width="100%" className='d-flex'>
                                <img src='/images/riasec/manual.png'  alt='manual' className="m-auto img-manual"/> 
                                </div>   
                                <div className='div-radio m-0'>                                    
                                    <p className='text--white px-0 px-lg-5 mx-0 mx-lg-5 t-w-manual m-0 text-center font-sarabun-bold'>ว้าวว.. เธอเป็นคนที่พิเศษมากเลย <span class="doNotWrap">เราขอถามต่ออีกนิดน๊าา</span>  <span class="doNotWrap">เพื่อให้แน่ใจว่าผลลัพธ์ที่ออกมาจะเหมาะกับเธอจริงๆ</span></p>   
                                    <p className="text-green t-g-manual text-center m-1">ถ้าให้เลือกเราคิดว่าตัวเองเหมาะกับ<span class="doNotWrap">ข้อไหนมากที่สุด?</span></p>
                                    <div className='px-0 px-lg-5'>
                                        <label htmlFor={`mRtop1`} style={{"width": "100%"}} className="label-radio px-2 R-top1" onClick={(event) => handleOnClickRadio(event,`mRtop1`)}><div className="radio-btn d-flex border-radius-250 border-green"><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="R" name={`mTop1`} data-c="R"  data-q="ชอบการลงมือทำจริงชอบกีฬาและกิจกรรมกลางแจ้ง" className="aws-m font-sarabun-bold" id={`mRtop1`} /><span className="font-sarabun-bold pl-2 t-manual">ชอบการลงมือทำจริงชอบกีฬาและกิจกรรมกลางแจ้ง</span></div></div></label>  
                                        <label htmlFor={`mItop1`} style={{"width": "100%"}} className="label-radio px-2 I-top1" onClick={(event) => handleOnClickRadio(event,`mItop1`)}><div className="radio-btn d-flex border-radius-250 border-green"><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="I" name={`mTop1`} data-c="I" data-q="สนใจในวิทยาศาสตร์และการแสวงหาความรู้แขนงต่างๆ"  className="aws-m font-sarabun-bold" id={`mItop1`}/><span className="font-sarabun-bold pl-2 t-manual">สนใจในวิทยาศาสตร์และการแสวงหาความรู้แขนงต่างๆ</span></div> </div></label>  
                                        <label htmlFor={`mAtop1`} style={{"width": "100%"}} className="label-radio px-2 A-top1" onClick={(event) => handleOnClickRadio(event,`mAtop1`)}><div className="radio-btn d-flex border-radius-250 border-green"><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="A" name={`mTop1`} data-c="A" data-q="ชอบช่วยเหลือผู้อื่น อยากเห็นผู้อื่นพัฒนา ชอบสร้างความสัมพันธ์ที่ดีกับคนรอบข้าง" className="aws-m font-sarabun-bold" id={`mAtop1`}/><span className="font-sarabun-bold pl-2 t-manual">ชอบช่วยเหลือผู้อื่น อยากเห็นผู้อื่นพัฒนา ชอบสร้างความสัมพันธ์ที่ดีกับคนรอบข้าง</span></div> </div></label>  
                                        <label htmlFor={`mStop1`} style={{"width": "100%"}} className="label-radio px-2 S-top1" onClick={(event) => handleOnClickRadio(event,`mStop1`)}><div className="radio-btn d-flex border-radius-250 border-green"><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="S" name={`mTop1`} data-c="S" data-q="มีความคิดสร้างสรรค์มีจินตนาการ เชื่อในสัญชาตญาณของตัวเอง" className="aws-m font-sarabun-bold" id={`mStop1`}/><span className="font-sarabun-bold pl-2 t-manual">มีความคิดสร้างสรรค์มีจินตนาการ เชื่อในสัญชาตญาณของตัวเอง</span></div>  </div></label>  
                                        <label htmlFor={`mEtop1`} style={{"width": "100%"}} className="label-radio px-2 E-top1" onClick={(event) => handleOnClickRadio(event,`mEtop1`)}><div className="radio-btn d-flex border-radius-250 border-green"><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="E" name={`mTop1`} data-c="E" data-q="มีความเป็นผู้นำสามารถโน้มน้าวใจ และมีอิทธิพลต่อการตัดสินใจของผู้อื่น" className="aws-m font-sarabun-bold" id={`mEtop1`}/><span className="font-sarabun-bold pl-2 t-manual">มีความเป็นผู้นำสามารถโน้มน้าวใจ และมีอิทธิพลต่อการตัดสินใจของผู้อื่น</span></div> </div></label>  
                                        <label htmlFor={`mCtop1`} style={{"width": "100%"}} className="label-radio px-2 C-top1" onClick={(event) => handleOnClickRadio(event,`mCtop1`)}><div className="radio-btn d-flex border-radius-250 border-green"><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="C" name={`mTop1`} data-c="C" data-q="ชอบจัดระบบข้อมูลตัวเลขมีความเป็นระเบียบสูง" className="aws-m font-sarabun-bold" id={`mCtop1`}/><span className="font-sarabun-bold pl-2 t-manual">ชอบจัดระบบข้อมูลตัวเลขมีความเป็นระเบียบสูง</span></div> </div></label>  
                                    </div>
                                    <Row>
                                    <Col className="main-riasec text-center pt-3 pb-1">       
                                        <Button className="riasec-btn-none btn font-sarabun-bold t-manual font-sarabun-bold mx-1 btn-next px-3" style={{"minWidth": "107px"}} onClick={handleClickNextM} >ตกลง &gt;</Button>
                                        <br></br>                                               
                                    </Col>                                          
                                    </Row>
                                    </div>
                                
                            </div>
                        </div>    
                    </Row>

                </div>

            </div>
         </Col>
        </Row>
    );

    let manual2     = (
        <Row className={`p-0 div-top2 ${hideTop2?'d-none':''}`} style={{"backgroundColor": "#F4F8FF"}}>        
        <Col xs={12} className={`div-manual main-riasec riasec-100 p-0`}  key='top2'>    
           <div className="q-div riasec-100">                
              <div className="riasec-100 story-page p-rl-15">
                  <Row style={{"paddingLeft": "0px", "paddingRight": "0px"}} className="riasec-pt-end">
                      <div style={{"minHeight": "80vh", "width": "100vw", "display":"flex"}}>
                          <div className="m-auto radio-top2 col-12">               
                              <div width="100%" className='d-flex'>
                              <img src='/images/riasec/manual.png'  alt='manual' className="m-auto img-manual"/> 
                              </div>   
                              <div className='div-radio m-0'>                                    
                                  <p className='text--white px-0 px-lg-5 mx-0 mx-lg-5 t-w-manual m-0 text-center font-sarabun-bold'>ว้าวว.. เธอเป็นคนที่พิเศษมากเลย <span class="doNotWrap">เราขอถามต่ออีกนิดน๊าา</span>  เพื่อให้แน่ใจว่าผลลัพธ์ที่ออกมาจะเหมาะกับเธอจริงๆ</p>   
                                  <p className="text-green t-g-manual text-center m-1">ถ้าให้เลือกอีกหนึ่งข้อ <span class="doNotWrap">เราคิดว่าตัวเราเหมาะกับข้อไหน?</span></p>
                                  <div className='px-0 px-lg-5'>
                                      <label htmlFor={`mRtop2`} style={{"width": "100%"}} className="label-radio px-2 R-top2" onClick={(event) => handleOnClickRadio(event,`mRtop2`)}><div className="radio-btn d-flex border-radius-250 border-green"><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="R" name={`mTop2`} data-c="R"  data-q="ชอบการลงมือทำจริงชอบกีฬาและกิจกรรมกลางแจ้ง" className="aws-m font-sarabun-bold" id={`mRtop2`} /><span className="font-sarabun-bold pl-2 t-manual">ชอบการลงมือทำจริงชอบกีฬาและกิจกรรมกลางแจ้ง</span></div></div></label>  
                                      <label htmlFor={`mItop2`} style={{"width": "100%"}} className="label-radio px-2 I-top2" onClick={(event) => handleOnClickRadio(event,`mItop2`)}><div className="radio-btn d-flex border-radius-250 border-green "><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="I" name={`mTop2`} data-c="I" data-q="สนใจในวิทยาศาสตร์และการแสวงหาความรู้แขนงต่างๆ"  className="aws-m font-sarabun-bold" id={`mItop2`}/><span className="font-sarabun-bold pl-2 t-manual">สนใจในวิทยาศาสตร์และการแสวงหาความรู้แขนงต่างๆ</span></div> </div></label>  
                                      <label htmlFor={`mAtop2`} style={{"width": "100%"}} className="label-radio px-2 A-top2" onClick={(event) => handleOnClickRadio(event,`mAtop2`)}><div className="radio-btn d-flex border-radius-250 border-green "><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="A" name={`mTop2`} data-c="A" data-q="ชอบช่วยเหลือผู้อื่น อยากเห็นผู้อื่นพัฒนา ชอบสร้างความสัมพันธ์ที่ดีกับคนรอบข้าง" className="aws-m font-sarabun-bold" id={`mAtop2`}/><span className="font-sarabun-bold pl-2 t-manual">ชอบช่วยเหลือผู้อื่น อยากเห็นผู้อื่นพัฒนา ชอบสร้างความสัมพันธ์ที่ดีกับคนรอบข้าง</span></div> </div></label>  
                                      <label htmlFor={`mStop2`} style={{"width": "100%"}} className="label-radio px-2 S-top2" onClick={(event) => handleOnClickRadio(event,`mStop2`)}><div className="radio-btn d-flex border-radius-250 border-green "><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="S" name={`mTop2`} data-c="S" data-q="มีความคิดสร้างสรรค์มีจินตนาการ เชื่อในสัญชาตญาณของตัวเอง" className="aws-m font-sarabun-bold" id={`mStop2`}/><span className="font-sarabun-bold pl-2 t-manual">มีความคิดสร้างสรรค์มีจินตนาการ เชื่อในสัญชาตญาณของตัวเอง</span></div>  </div></label>  
                                      <label htmlFor={`mEtop2`} style={{"width": "100%"}} className="label-radio px-2 E-top2" onClick={(event) => handleOnClickRadio(event,`mEtop2`)}><div className="radio-btn d-flex border-radius-250 border-green "><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="E" name={`mTop2`} data-c="E" data-q="มีความเป็นผู้นำสามารถโน้มน้าวใจ และมีอิทธิพลต่อการตัดสินใจของผู้อื่น" className="aws-m font-sarabun-bold" id={`mEtop2`}/><span className="font-sarabun-bold pl-2 t-manual">มีความเป็นผู้นำสามารถโน้มน้าวใจ และมีอิทธิพลต่อการตัดสินใจของผู้อื่น</span></div> </div></label>  
                                      <label htmlFor={`mCtop2`} style={{"width": "100%"}} className="label-radio px-2 C-top2" onClick={(event) => handleOnClickRadio(event,`mCtop2`)}><div className="radio-btn d-flex border-radius-250 border-green "><div style={{"width": "100%", "paddingLeft": "5px"}}><input type="radio" value="C" name={`mTop2`} data-c="C" data-q="ชอบจัดระบบข้อมูลตัวเลขมีความเป็นระเบียบสูง" className="aws-m font-sarabun-bold" id={`mCtop2`}/><span className="font-sarabun-bold pl-2 t-manual">ชอบจัดระบบข้อมูลตัวเลขมีความเป็นระเบียบสูง</span></div> </div></label>  
                                  </div>
                                  <Row>
                                  <Col className="main-riasec text-center pt-3 pb-1">    
                                    <Button className="riasec-btn btn font-sarabun-bold t-manual font-sarabun-bold mx-1 px-3 m-back" onClick={handleClickM}  style={{"minWidth": "107px"}}>&lt; ย้อนกลับ</Button>   
                                    <Button className="riasec-btn-none btn font-sarabun-bold t-manual font-sarabun-bold mx-1 btn-next px-3" style={{"minWidth": "107px"}} onClick={() => resendSendAnswer()}>ตกลง &gt;</Button>
                                      <br></br>                                               
                                  </Col>                                          
                                  </Row>
                                  </div>
                              
                          </div>
                      </div>    
                  </Row>

              </div>

          </div>
       </Col>
      </Row>
    );


    return (
        <Row className="bg-blue-riasec riasec-page"  >
        <Col>
            {html}
            {manual1}
            {manual2}
            <Row>
                <Col className="main-riasec">
                    {/* <Button className="btn-pink btn font-sarabun-bold t-10 btn font-sarabun-bold" onClick={handleClick}  id="previous">ย้อน555</Button>
                    <Button className="btn-pink btn font-sarabun-bold t-10 btn font-sarabun-bold pull-right" onClick={handleClickNext}  id="next">ถัดไป</Button>
                    <br></br> */}
                    {/* <Button className="bluegrey d-inline font-sarabun-bold border-radius-10" onClick={() => sendAnswer()}>ส่งคำตอบ</Button> */}
                </Col>
            </Row>       
            <Modal
                show={showAlert}
                onHide={() => { setShowAlert(false); }}              
                aria-labelledby="contained-modal-title-vcenter"
                // className="strength-modal"
                centered
                className="alert-modal"
            >
                <Modal.Header closeButton className="alert-header">
                </Modal.Header>
                <Modal.Body className="font-sarabun text-center pb-4 pt-0">
                    <p>{textAlert}</p>
                    <Button className="bluesky d-inline py-1 py-md-2 px-5 m-1 font-sarabun-bold border-radius-10" onClick={() => { setShowAlert(false); }}>ตกลง</Button>                  

                </Modal.Body>
            </Modal>    
        </Col>
        <MyVerticallyCenteredModal
                    show={modalShow}
                    onHide={() => { setModalShow(false); }}
                />
        </Row>
    )

    
function MyVerticallyCenteredModal(props) {
    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            className="strength-modal"
            centered
        >
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
            <Row className="pt-0 pb-4 person-choose-strength px-md-4">
                  <Col>
                  {/* ---------------------------------------------------- */}
                  <div className="px-2 px-md-4 w-100">
         
                          <Row className="px-0" >
                                  <Col xs={12}>
                                      <h2 class="text-green pb-3 py-md-3 text-center">RIASEC คืออะไร?</h2>                   
                                      <p className='font-sarabun-bold'>ค้นหาตัวตนผ่านมิติอาชีพอย่างครบถ้วนตามทฤษฎีของ Prof. John Holland (RIASEC) ด้วย Task-based Activitie</p> 
                                  </Col>         
                                  <Col xs={12}>
                                      <h2 class="text-green pb-3 py-md-3 text-center">ทฤษฎีของ Holland</h2>          
                                      <p className='font-sarabun-bold'>
                                          <ul>                                    
                                              <li>ได้รับการยอมรับและถูกนำไปใช้ในการให้คำปรึกษาด้านอาชีพอย่างกว้างขวาง</li>
                                              <li>รับรองโดยงานวิจัยที่ต่อเนื่องกว่า 60 ปี</li>
                                              <li>ถูกนำไปใช้ในโรงเรียน มหาวิทยาลัยและองค์กรทั่วโลก</li>
                                              <li>ใช้โดยกระทรวงแรงงานของสหรัฐอเมริกา</li>
                                              <li>ใช้โดยหน่วยงานรัฐบาลทั่วโลก เช่น ออสเตรเลีย แคนาดา สวิตเซอร์แลนด์ ฯลฯ</li>
                                          </ul>
                                      </p>          
                                  </Col>              
                                      
                          </Row>
                          <Row className="py-2 mt-3">
                              <Col xs={12} md={5} className="">
                                  <img src='/images/riasec/riasec_meaning.png' width={'100%'} alt='Riasec Meaning' /> 
                              </Col>
                              <Col xs={12} md={7} className="d-flex">
                                  <div className='blue-bg p-3 p-md-5 t-1 m-auto font-sarabun-bold border-radius-125'>
                                      <p className='text-indent-18'><span className='text-green'>R:</span> ชอบการลงมือทำจริงชอบกีฬาและกิจกรรมกลางแจ้ง</p>
                                      <p className='text-indent-18'><span className='text-green'>I:</span> สนใจในวิทยาศาสตร์และการแสวงหาความรู้แขนงต่างๆ</p>
                                      <p className='text-indent-18'><span className='text-green'>A:</span> ชอบช่วยเหลือผู้อื่น อยากเห็นผู้อื่นพัฒนาชอบสร้างความสัมพันธ์ที่ดีกับคนรอบข้าง</p>
                                      <p className='text-indent-18'><span className='text-green'>S:</span> มีความคิดสร้างสรรค์มีจินตนาการ เชื่อในสัญชาตญาณของตัวเอง</p>
                                      <p className='text-indent-18'><span className='text-green'>E:</span> มีความเป็นผู้นำสามารถโน้มน้าวใจ และมีอิทธิพลต่อการตัดสินใจของผู้อื่น</p>
                                      <p className='text-indent-18'><span className='text-green'>C:</span> ชอบจัดระบบข้อมูลตัวเลข มีความเป็นระเบียบสูง</p>
                                  </div>    
                              </Col>                                    
                          </Row>                
                      </div>

                  {/* ---------------------------------------------------- */}
                  </Col>
              </Row>
            </Modal.Body>
        </Modal>
    );
}
}




export default RFStudentEvaluate